import { InjectionToken } from '@angular/core';

/**
 * How many times to retry calling the feature flag API
 */
export const FEATURE_FLAG_RETRIES = new InjectionToken<number>('FEATURE_FLAG_RETRIES');
